import { OfferProduct } from '@models';

export class OfferPackage {
	id: number;
	offer_id: number;
	name: string;
	show_total: boolean;
	sort_order: number;
	created_at: string;
	updated_at: string;

	products: OfferProduct[];

	constructor() {
		this.id = -1;
		this.products = [];
		this.name = "Pakket";
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/offer_package.ts